import React, { useState } from 'react'
import { IconButton, makeStyles, TextField, TextFieldProps, Typography } from '@material-ui/core'
import { RefreshIcon } from './icons'
import { strings } from './strings'
import { CaptchaInfo, useCaptchaApi } from './api'
import Axios from 'axios'

export function useCaptcha(
  options?: TextFieldProps,
): [JSX.Element | undefined, () => void, () => CaptchaInfo] {
  const classes = useStyle()
  const [value, setValue] = useState('')
  const { captchaKey, refresh, error } = useCaptchaApi()

  const refreshAndReset = () => {
    refresh()
    setValue('')
  }

  const getInfo = (): CaptchaInfo => {
    return {
      key: captchaKey!,
      value,
    }
  }

  const captcha = (
    <div className={classes.root}>
      {error && <Typography color="error">{error.message}</Typography>}
      {!error && <img alt="captcha" src={`${Axios.defaults.baseURL}/captcha/${captchaKey}.png`} />}
      <IconButton onClick={refreshAndReset} tabIndex="-1">
        <RefreshIcon fontSize="large" />
      </IconButton>
      <TextField
        margin="normal"
        variant="outlined"
        fullWidth
        label={strings.captcha}
        autoComplete="off"
        required
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        {...options}
      />
    </div>
  )

  return [captcha, refreshAndReset, getInfo]
}

const useStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: '60px auto',
    gap: theme.spacing(0, 0.5),
    marginTop: theme.spacing(1),
    '& button': {
      width: theme.spacing(6),
      height: theme.spacing(6),
      alignSelf: 'center',
    },
    '& div': {
      gridColumn: '1 / 3',
    },
  },
}))
